import React from 'react';
import { Typography } from 'antd';
import { FileImageOutlined, FileOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import {
  formatMaterialSize,
  getMaterialSourceLabel,
  getMaterialStatusLabel,
  getSourceDisplayName,
  getSourceTypeLabel,
  inferSourceKind,
} from '../presentation/sourceMaterialView.js';
import SourceRowActions from './SourceRowActions.jsx';

const { Text } = Typography;
const firstTruthy = (...values) => values.find(Boolean);
const SOURCE_ICONS = new Map([
  ['word', <FileWordOutlined />],
  ['pdf', <FilePdfOutlined />],
  ['image', <FileImageOutlined />],
]);

export default function SourceMaterialRow({
  source,
  index,
  handleViewSourceDetail,
  handleDeleteCancel,
  handleDeleteClick,
  handleRetrySource,
  pendingDeleteSourceId,
  sourceRemovingId,
  themeTokens,
}) {
  const sourceRecord = Object.assign({}, source);
  const normalizedSourceId = String(firstTruthy(sourceRecord.source_id, sourceRecord.id) ?? '').trim();
  const sourceName = getSourceDisplayName(source, firstTruthy(normalizedSourceId, `资料 ${index + 1}`));
  const sourceKind = inferSourceKind(sourceName, firstTruthy(sourceRecord.mime_type, sourceRecord.type));
  const metadata = [
    getSourceTypeLabel(sourceKind),
    formatMaterialSize(source.size),
    getMaterialStatusLabel(source.status),
  ].filter(Boolean).join(' · ');
  const openDetails = () => handleViewSourceDetail(source);
  const handleRowKeyDown = (event) => {
    if (!['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    openDetails();
  };

  return (
    <div
      aria-label={`查看资料详情：${sourceName}`}
      className="flare-source-list-row"
      onClick={openDetails}
      onKeyDown={handleRowKeyDown}
      role="button"
      tabIndex={0}
    >
      <span className="flare-source-list-icon" aria-hidden="true">
        {SOURCE_ICONS.get(sourceKind) ?? <FileOutlined />}
      </span>
      <span className="flare-source-list-content">
        <Text className="flare-source-list-name" ellipsis strong>
          {sourceName}
        </Text>
        <Text className="flare-source-list-metadata" ellipsis type="secondary">
          {metadata}
        </Text>
        {sourceRecord.error_message ? (
          <Text className="flare-source-list-error" ellipsis>
            {String(sourceRecord.error_message)}
          </Text>
        ) : null}
      </span>
      <span className="flare-source-list-trailing">
        <Text className="flare-source-list-provenance" type="secondary">
          {getMaterialSourceLabel(source.source)}
        </Text>
        <SourceRowActions
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteClick={handleDeleteClick}
          handleRetrySource={handleRetrySource}
          normalizedSourceId={normalizedSourceId}
          pendingDeleteSourceId={pendingDeleteSourceId}
          source={source}
          sourceRemovingId={sourceRemovingId}
          themeTokens={themeTokens}
        />
      </span>
    </div>
  );
}
